import React from 'react';
import styles from './EventLikedToast.module.scss';
import { useUserData } from '@/src/listings/hooks/useUserData';
import { useAppContext } from '@/src/listings/components/_shared/context/AppContext';
import { FormattedMessage } from 'react-intl';

export const EventLikedToast: React.FC = () => {
  const { userId } = useUserData();
  const {
    data: { serverUrl },
  } = useAppContext();
  const likesUrl = userId ? `${serverUrl}/u/${userId}/favorites/events` : null;

  return (
    <div className={styles.container}>
      <span className={styles.message}>
        <FormattedMessage
          id="Event saved"
          defaultMessage="Event saved"
          description="Event saved message in toast after user likes an event"
        />
      </span>
      {likesUrl && (
        <a className={styles.link} href={likesUrl} target="_blank" rel="noopener noreferrer">
          <FormattedMessage
            id="Go to likes"
            defaultMessage="Go to likes"
            description="Go to likes link in toast after user likes an event"
          />
        </a>
      )}
    </div>
  );
};
